import JamiePNG from '@lib/core/src/assets/jamie.png';
import palette from '@lib/core/src/theme/palette';
import { Stack, Typography } from '@mui/material';

const JamieChiefOfStaff = () => (
  <Stack direction="row" alignItems="center" gap={1}>
    <img src={JamiePNG} alt="AI" width={32} />
    <Stack>
      <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>Jamie</Typography>
      <Typography sx={{ color: palette.grey[400], fontSize: '13px' }}>Chief of staff</Typography>
    </Stack>
  </Stack>
);

export default JamieChiefOfStaff;
